import { call, put, select, takeLatest } from 'redux-saga/effects';
import { metadataActions as actions } from '.';
import { MetadataResponse } from './types';
import { selectBasicForm } from 'app/features/selectedFilters/slice/selectors';

export function* fetchMetadata() {
  const { getMetadataSuccess, getMetadataFail } = actions;
  const valveType = yield select(state => selectBasicForm(state, 1));

  try {
    const itemsMetadataResponse = yield call(
      fetch,
      `/valve-configurator/api/metadata?valveType=${valveType.toUpperCase()}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    if (itemsMetadataResponse.status !== 200) {
      return yield put(getMetadataFail('failed to fetch'));
    } else {
      const itemsMetadata: Array<MetadataResponse> =
        yield itemsMetadataResponse.json();

      if (!itemsMetadata) {
        return yield put(getMetadataFail('No metadatas fetched'));
      }

      return yield put(getMetadataSuccess({ itemsMetadata, valveType }));
    }
  } catch (e) {
    yield put(getMetadataFail(e));
  }
}
export function* metadataSaga() {
  yield takeLatest(actions.getMetadata.type, fetchMetadata);
}
